import { useEffect, useState } from 'react'

// The URL hash (/#slug) is the source of truth for the active tab.
// This hook listens for the browser's `hashchange` event and returns the current hash.
// Whenever the hash changes, the component will re-render with the new hash.
const getHash = () => window.location.hash.slice(1)

/**
 * Returns the slug of the tab named by the URL hash, or undefined when
 * the hash is missing or doesn't match any of `slugs`.
 */
const useHashTab = (slugs: string[]) => {
  // Browsers do not send the hash to the server, so server rendering (and hydration)
  // always starts with no hash, and the component shows its default tab.
  const [hash, setHash] = useState('')

  useEffect(() => {
    const readHash = () => setHash(getHash())
    // pick up the hash once the page loads
    readHash()
    window.addEventListener('hashchange', readHash)
    return () => window.removeEventListener('hashchange', readHash)
  }, [])

  return slugs.includes(hash) ? hash : undefined
}

export default useHashTab
